import Vue from 'vue';
import router from '@/router';

const INVALID_CREDENTIALS = "invalid_credentials";
const UNAUTHORIZE = "unauthorized";

//suporte@soledadetecnologia.com.br
const ErrorService = {
    http(_response) {
        const code = _response ? _response.status : 0;
        const error = _response ? _response.data.error : null;

        const message = this.translate(error);

        if (code == 401) {
            router.push({
                name: 'login'
            });
        } else if (code == 404) {
            Vue.$notify.danger("Recurso não encontrado!");
        } else if (code == 406) {
            Vue.$notify.danger("Dados incorretos!");
        } else if (code != 422) {
            Vue.$notify.danger(message);
        }
    },
    translate(_error) {
        switch (_error) {
            case UNAUTHORIZE:
                return "Você não possui permissão para acessar esse módulo!";

            case INVALID_CREDENTIALS:
                return "As credenciais informadas estão incorretas!";
        }

        return "Falha desconhecida!";
    }
};

export default ErrorService;